import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class LuckyFire103 extends SlotGameType1_3{}